import { useTranslation } from 'react-i18next'
import { ConfirmModal } from '@/components/modal'
import { MATCH_SOURCE_DUPR } from '@/constants/Common'
import { APP_CUSTOM_ERROR } from '@/constants/MessageConstants'
import { useAppSelector } from '@/hooks/useRedux'
import { userSelector } from '@/pages/user/selectors'
import { Match } from '@/types'
import { useConfirmMatch, useDirectorConfirmBracketMatch, useGetMatch } from '@/services'
import toast from 'react-hot-toast'
type ValidateModalProps = {
  match: Match
  open: boolean
  onClose: () => void
  onUpdated?: (updated: Match) => void
}

export function ValidateModal({ match, open, onClose, onUpdated }: ValidateModalProps) {
  const { t } = useTranslation()
  const { user } = useAppSelector(userSelector)

  const { mutate: confirmMatch } = useConfirmMatch()
  const { mutate: confirmBracketMatch } = useDirectorConfirmBracketMatch()
  const { mutate: getMatch } = useGetMatch()

  const extractErr = (err: unknown) => {
    if (
      typeof err === 'object' &&
      err !== null &&
      'response' in err &&
      typeof (err as { response?: { data?: { message?: string } } }).response?.data?.message === 'string'
    ) {
      return (err as { response: { data: { message: string } } }).response.data.message
    }
    return APP_CUSTOM_ERROR
  }

  const refresh = (id: number) =>
    getMatch(id, {
      onSuccess: (data) => {
        onUpdated?.(data)
        onClose()
      },
      onError: (err: unknown) => toast.error(extractErr(err)),
    })

  const handleSubmit = () => {
    const onSuccess = () => refresh(match.id)
    const onError = (err: unknown) => toast.error(extractErr(err))

    if (match.matchSource === MATCH_SOURCE_DUPR) {
      confirmMatch({ matchId: match.id }, { onSuccess, onError })
    } else {
      confirmBracketMatch(
        { matchId: match.id, leagueMatchId: match.leagueMatchId ?? 0, userId: user?.id ?? 0 },
        { onSuccess, onError }
      )
    }
  }

  return (
    <ConfirmModal
      open={open}
      onSubmit={handleSubmit}
      onClose={onClose}
      title={`${t('performance.validateMatch')}?`}
      desc={`${t('performance.confirmValidateMatch')} ${
        match.matchSource !== MATCH_SOURCE_DUPR ? t('performance.matchSourceLeague') : ''
      }`}
    />
  )
}
